module.exports = __webpack_public_path__ + "img/repair.0bc2d197.gif";